export default "__VITE_ASSET__FB$96QDK__"